/**
 * Instagram shorts carousel: scroll-snap track, lazy embeds, click-to-play posters.
 * Touch is left to the browser so Instagram's own play control can run.
 */
(function () {
  var SELECTOR = '[data-insta-shorts]';
  var MOBILE = '(max-width: 768px)';

  function isMobile() {
    return window.matchMedia(MOBILE).matches;
  }

  function init(root) {
    if (!root || root.dataset.instaShortsReady === 'true') return;
    root.dataset.instaShortsReady = 'true';

    var list = root.querySelector('[data-insta-shorts-list]');
    if (!list) return;

    setupLazyEmbeds(root);
    setupPosters(root);
    setupExclusivePlay(root);
    setupMobilePlay(root);
    setupNav(root, list);
  }

  function setupLazyEmbeds(root) {
    var frames = root.querySelectorAll('iframe[data-src]');
    if (!frames.length) return;

    var load = function (iframe) {
      if (!iframe || iframe.dataset.loaded === 'true') return;
      iframe.src = iframe.dataset.src;
      iframe.removeAttribute('data-src');
      iframe.dataset.loaded = 'true';
    };

    if (!('IntersectionObserver' in window)) {
      frames.forEach(load);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          load(entry.target);
          obs.unobserve(entry.target);
        });
      },
      { root: null, rootMargin: '200px 80px', threshold: 0.01 }
    );

    frames.forEach(function (iframe) {
      observer.observe(iframe);
    });
  }

  function stopOtherEmbeds(root, keep) {
    root.querySelectorAll('[data-insta-shorts-embed]').forEach(function (iframe) {
      if (iframe === keep) return;
      var src = iframe.getAttribute('src');
      if (!src || src === 'about:blank') return;
      var clone = iframe.cloneNode(false);
      clone.setAttribute('src', src);
      iframe.parentNode.replaceChild(clone, iframe);
    });
  }

  function setupPosters(root) {
    root.querySelectorAll('[data-insta-shorts-poster]').forEach(function (button) {
      button.addEventListener('click', function () {
        var card = button.closest('[data-insta-shorts-card]');
        if (!card) return;
        var iframe = card.querySelector('iframe');
        var src = button.getAttribute('data-embed-src');
        if (!iframe || !src) return;

        stopOtherEmbeds(root, iframe);
        iframe.src = src;
        iframe.dataset.loaded = 'true';
        iframe.removeAttribute('data-src');
        iframe.removeAttribute('hidden');
        button.hidden = true;
      });
    });
  }

  function setupExclusivePlay(root) {
    if (isMobile()) return;

    var covers = function () {
      return root.querySelectorAll('[data-insta-shorts-cover]');
    };

    var setActiveCard = function (activeCard) {
      covers().forEach(function (cover) {
        var card = cover.closest('[data-insta-shorts-card]');
        cover.style.pointerEvents = card === activeCard ? 'none' : '';
      });
    };

    root.querySelectorAll('[data-insta-shorts-card]').forEach(function (card) {
      if (card.querySelector('[data-insta-shorts-cover]')) return;
      if (card.querySelector('[data-insta-shorts-poster]')) return;

      var cover = document.createElement('span');
      cover.setAttribute('data-insta-shorts-cover', '');
      cover.className = 'custom-insta-shorts__cover';
      card.appendChild(cover);

      cover.addEventListener('pointerdown', function () {
        var iframe = card.querySelector('[data-insta-shorts-embed]');
        stopOtherEmbeds(root, iframe);
        setActiveCard(card);
      });
    });
  }

  function setupMobilePlay(root) {
    if (!isMobile()) return;

    var android = /Android/i.test(navigator.userAgent);

    root.querySelectorAll('[data-insta-shorts-open]').forEach(function (link) {
      var url = link.getAttribute('href');
      if (!url) return;

      link.removeAttribute('target');

      if (!android) return;

      var shortcode = '';
      var parts = url.split('/reel/');
      if (parts.length < 2) parts = url.split('/reels/');
      if (parts.length < 2) parts = url.split('/p/');
      if (parts.length >= 2) {
        shortcode = parts[1].split('/')[0].split('?')[0].split('#')[0];
      }
      if (!shortcode) return;

      link.setAttribute(
        'href',
        'intent://www.instagram.com/reel/' +
          shortcode +
          '/#Intent;scheme=https;package=com.instagram.android;S.browser_fallback_url=' +
          encodeURIComponent(url) +
          ';end'
      );
    });
  }

  function setupNav(root, list) {
    var prev = root.querySelector('[data-insta-shorts-prev]');
    var next = root.querySelector('[data-insta-shorts-next]');
    if (!prev && !next) return;

    var slideBy = function (direction) {
      var slides = list.querySelectorAll('[data-insta-shorts-slide]');
      if (!slides.length) return;

      if (isMobile()) {
        var listRect = list.getBoundingClientRect();
        var center = listRect.left + listRect.width / 2;
        var current = 0;
        var closest = Infinity;
        slides.forEach(function (slide, index) {
          var rect = slide.getBoundingClientRect();
          var slideCenter = rect.left + rect.width / 2;
          var distance = Math.abs(slideCenter - center);
          if (distance < closest) {
            closest = distance;
            current = index;
          }
        });
        var target = slides[current + direction];
        if (target) {
          target.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
        }
        return;
      }

      var slide = slides[0];
      var styles = window.getComputedStyle(list);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      var amount = slide.getBoundingClientRect().width + gap;
      list.scrollBy({ left: direction * amount, behavior: 'smooth' });
    };

    var update = function () {
      var max = Math.max(0, list.scrollWidth - list.clientWidth - 2);
      var atStart = list.scrollLeft <= 2;
      var atEnd = list.scrollLeft >= max;
      if (prev) {
        prev.disabled = atStart;
        prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
      }
      if (next) {
        next.disabled = atEnd;
        next.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
      }
    };

    if (prev) prev.addEventListener('click', function () { slideBy(-1); });
    if (next) next.addEventListener('click', function () { slideBy(1); });
    list.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function scan() {
    document.querySelectorAll(SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector(SELECTOR);
    if (root) {
      delete root.dataset.instaShortsReady;
      init(root);
    }
  });
})();
